import { render, staticRenderFns } from "./SaleMistakes.vue?vue&type=template&id=0ab00870&"
import script from "./SaleMistakes.vue?vue&type=script&lang=js&"
export * from "./SaleMistakes.vue?vue&type=script&lang=js&"
import style0 from "./SaleMistakes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports